const config = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en'],
    localeDetection: false,
  },
};

module.exports = config;
